import { TApplicationState } from "../rootReducer";

export const adminHasBeenAuthorized = (state: TApplicationState) =>{
    return state.adminAnketas.adminData.authorized
}